import { JudgementOnMeritsDoc } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';

export const JUDICIARY_DOCUMENT_ID = '001';
export const CONSULTING_DOCUMENT_ID = '002';
export const EXPERTISE_ACCOUNTING_ID = 2;
export const EXPERTISE_MECHANIC_ID = 3;
export const EXPERTISE_MEDICAL_ID = 1;

export const MISSION_NATURE = {
  TRANSACTION: 'TRANSACTION',
  JUDICIARY: 'JUDICIARY',
  PROVISIONAL_JUDICIARY: 'PROVISIONAL_JUDICIARY',
};

export const EXPERTISE_INIT_STATE: any = {
  itt: null,
  ipp: null,
  medicalPharmaceuticalFees: null,
  comment: '',
  thirdPartyAppeal: null,
  pretiumDoloris: null,
  aestheticDamageWithConsequence: null,
  aestheticDamageWithoutConsequence: null,
  careerPrejudice: null,
  schoolingPrejudice: null,
  victimIncome: '',
  isDeathRelatedToClaim: undefined,
};

export const EXPERTISE_INIT_STATE_MECHANIC: any = {
  damageAmount: null,
};
export const DOCUMENT_INIT_STATE: JudgementOnMeritsDoc = {
  url: '',
  name: '',
  type: '',
};
export const MISSION_EXPERTISE_VICTIM_TYPE = {
  RAPPORT_CONSEIL: 'RAPPORT_CONSEIL',
  APPRECIATION: 'APPRECIATION',
};
